export default {
  title: {
    fontFamily: 'NotoSansKR, Chronicle Display, Times New Roman, serif',
    marginBlockEnd: '-16px',
    fontWeight: 'bold'
  },
  preTitle: {
    fontFamily: 'NotoSansKR, Chronicle Display, Times New Roman, serif',
    margin: '0 0 24px',
    fontWeight: 'bold'
  }
}
